function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M95.6 79.3l-14-14.2s-1.7-1-3.2.5c-1.6 1.5-.4 3.2-.4 3.2L92 83c2.4 2.4 2.6 5.7.2 8.1-2.4 2.7-6.1 3.3-8.8.5L69.3 77.4s-1.9-1-3.3.4c-1.5 1.5-.2 3.1-.2 3.1l14 14.2c4.2 4.2 11.5 4.2 15.8 0 2.1-2.1 3.3-4.9 3.3-7.9 0-2.7-1.2-5.8-3.3-7.9zM79.2 40.6c0-10.2-3.9-20-11.2-27.4C60.6 5.8 50.7 2 40.5 2s-20 3.9-27.4 11.2C5.7 20.6 1.9 30.4 1.9 40.6s3.9 20 11.2 27.4c7.4 7.4 17.2 11.2 27.4 11.2 10.5 0 20-3.9 27.4-11.2 7.4-7.3 11.3-17.2 11.3-27.4zM40.5 73.7c-8.8 0-17.2-3.5-23.6-9.8S7.1 49.1 7.1 40.3s3.5-17.2 9.8-23.6 14.8-9.8 23.6-9.8c9.1 0 17.6 3.5 23.6 9.8 6.3 6.3 9.8 14.8 9.8 23.6s-3.5 17.2-9.8 23.6-14.8 9.8-23.6 9.8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1 13.6c-.9-.1-10.1-.3-19.2 7.4s-9.1 19.5-9.1 20.6c.1.3.5 3 3.3 2.9 2.1-.2 2.6-2.8 2.6-3.2.1-.8-.7-10.2 7.7-16.8 7.8-6.1 12.3-4.7 15.4-5.8 1.6-.6 2.2-1.9 2.1-3-.2-1.2-1.5-2.1-2.8-2.1z"
});

var SvgMenuSearch = function SvgMenuSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
};

export default SvgMenuSearch;